import { routeComponentImports } from '@/router/routes';
import { idle } from '@lib/idle';

// Warm all lazy route chunks during idle time so in-app navigation never waits on a
// chunk download. Sequential rather than parallel to stay out of the way of anything
// more important happening right after boot.
export function preloadRouteChunks() {
  const queue = [...routeComponentImports];

  function next() {
    const load = queue.shift();
    if (!load) return;
    // Chunk-load failures (e.g. a deploy replaced the hashed bundles) are non-fatal
    // here — the router's onError handler deals with that on actual navigation.
    load()
      .catch(() => {})
      .finally(() => idle(next));
  }

  idle(next);
}
